import { render, staticRenderFns } from "./CompanyScope.vue?vue&type=template&id=fc840ab8&scoped=true"
import script from "./CompanyScope.vue?vue&type=script&lang=js"
export * from "./CompanyScope.vue?vue&type=script&lang=js"
import style0 from "./CompanyScope.vue?vue&type=style&index=0&id=fc840ab8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc840ab8",
  null
  
)

export default component.exports